<template>
  <div class="row pl-3 pb-3 pr-3 pt-1 mr">
    <div class="col-12 col-md-10 px-0">
      <div class="row">
        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Tipo de Recurso:
          </div>
          <div class="regular" v-text="item.resourceType.name || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Número de Puesto:
          </div>
          <div class="regular" v-text="item.positionNumber || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Tipo de Asistente:
          </div>
          <div class="regular" v-text="item.assistantType.name || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Jornada Diaria:
          </div>
          <div class="regular" v-text="item.dailyShift.name || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Año Académico:
          </div>
          <div class="regular" v-text="item.academicYear.description || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Tiempo en Servicio:
          </div>
          <div class="regular" v-text="item.timeInService || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Fecha desde:
          </div>
          <div class="regular" v-text="dateFormat(item.fromDate)" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Fecha hasta:
          </div>
          <div class="regular" v-text="dateFormat(item.toDate)" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Región:
          </div>
          <div class="regular" v-text="item.region.name || '-'" />
        </div>

        <div class="col-6 col-md-2 pt-3">
          <div class="regular text-gray">
            Municipio:
          </div>
          <div class="regular" v-text="item.municipality.name || '-'" />
        </div>

        <div class="col-12 col-md-4 pt-3 mb-md-0 mb-3">
          <div class="regular text-gray">
            Escuela:
          </div>
          <div class="regular" v-text="item.school.name || '-'" />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-2 px-0">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'SchoolInformationItem',
  props: {
    item: { type: Object, default: null },
    submitted: { type: Boolean, default: false },
  },
  methods: {
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale('es')
          .format('DD/MMM/YYYY');
      }
      return '-';
    },
  },
};
</script>

<style lang="scss" scoped></style>
